import { Component } from '@angular/core';
import { ReservationService } from '../../services/reservation.service';
import { JsonPipe, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenStorageService } from '../../services/token-storage.service';
import { FooterComponent } from "../../components/footer/footer.component";
import { S3UploadService, UploadedImage } from '../../services/uploadImages';
import { AdminRecepcionNavbarComponent } from '../../components/admin-recepcion-navbar/admin-recepcion-navbar.component';
import { DetailComponent } from '../estadias/detail/detail.component';
import {NavbarComponent} from '../../components/navbar/navbar.component'
@Component({
  selector: 'app-admin-recepcion',
  imports: [FormsModule, JsonPipe, CommonModule, AdminRecepcionNavbarComponent, FooterComponent,DetailComponent,NavbarComponent],
  templateUrl: './admin-recepcion.component.html',
  styleUrl: './admin-recepcion.component.css',
  providers: [ReservationService],
  standalone: true
})
export class AdminRecepcionComponent {
 estadias: any[] = [];
  alojamientos: any;
  reservationId: string = '';
  paymentId: string = '';
  reservationData: any = null;
  documentData: any = null;
  selectedPaymentMethod: string | null = null;
  loading: boolean = false;
  error: string = '';
  documentImage: any = null;
  documentImagePreview: string = '';
  loadingDocumentImage: boolean = false;
  errorDocumentImage: string = '';
  isDragOver: boolean = false;
  uploadProgress = {
    show: false,
    percentage: 0,
    uploaded: 0,
    total: 0
  };

  constructor(
    private reservationService: ReservationService,
    private readonly tokenStorage: TokenStorageService,
    readonly s3UploadService: S3UploadService,
   
  ) { 
  
  }

  searchReservations() {
    this.loading = true;
    this.error = '';
    const accessToken = this.tokenStorage.getAccessToken() || undefined;
    this.reservationService.getReservation(this.reservationId, accessToken)
      .subscribe({
        next: (data) => {
          this.reservationData = data;
          this.paymentId = data.reservation?.paymentId || '';
          this.loading = false;
          console.log(this.reservationData);
        },
        error: (err) => {
          this.error = 'No se encontró la reserva o hubo un error.';
          this.loading = false;
        }
      });
    this.reservationService.getReservationDocument(this.reservationId, 'identidad', this.tokenStorage.getAccessToken() || '').subscribe({
      next: (data) => { this.documentData = data.document || undefined; console.log(this.documentData); },
      error: (err) => console.log(err)
    });

  }


  onHostingSelectedFromDetail(hosting: any) {
    this.alojamientos = [hosting];
    
    this.cargarEstadias(this.alojamientos);

}


cargarEstadias(alo :any) {
  
    const user = this.tokenStorage.getUser();
    console.log('user', user?.attributes);
    

const alojamientosStr = alo.map((alo:any) => alo.id).join(',');

    console.log('IDs alojamientos', alojamientosStr)
    this.reservationService
      .getStays(alojamientosStr, this.tokenStorage.getAccessToken() || '')
      .subscribe({
        next: (resp: any) => {
          const reservas = resp.estadias || [];

          this.estadias = reservas.map((res: any) => {
            const alojamiento = alo.find((alo:any) => alo.id === res.hotelId);

            // Buscar la habitación correspondiente dentro del array `rooms` si existe
            let room = null;
            if (Array.isArray(alojamiento?.rooms)) {
              room = alojamiento.rooms.find((r: any) => r.room_id === res.roomId);
            } else if (alojamiento?.room && alojamiento.room.room_id === res.roomId) {
              // Caso en que viene como objeto único
              room = alojamiento.room;
            }

            return {
              ...res,
              hotel_name: alojamiento?.name || res.hotelId,
              hotel_type: alojamiento?.type,
              room_name: room?.type || res.roomId,
              room_number: room?.number,
            };
          });

          this.loading = false;
          console.log('[DEBUG] Estadías enriquecidas:', this.estadias);
          const id = this.estadias[0].reservationId;
          this.reservationId=id;
        },
        error: (err) => {
          
          this.loading = false;
        },
      });
  }

 

  getIdentificationDocument(reservationId: string) {
    this.reservationService.getReservationDocument(reservationId, 'identidad', this.tokenStorage.getAccessToken() || '').subscribe({
      next: (data) => { this.documentData = data.document || undefined },
      error: (err) => console.log(err)
    });
  }

  confirmarPago(method: string | null) {
    if (!method) return;
    switch (method) {
      case 'billetera digital':
        // Lógica para billetera digital        
        this.reservationService.updateReservationPaymentStatusAndPaymentMethod(this.reservationId, this.paymentId, method, this.tokenStorage.getAccessToken() || '').subscribe({
          next: (response) => this.searchReservations(),
          error: (err) => console.log(err)
        });
        break;
      case 'efectivo':
        // Lógica para efectivo        
        this.reservationService.updateReservationPaymentStatusAndPaymentMethod(this.reservationId, this.paymentId, method, this.tokenStorage.getAccessToken() || '').subscribe({
          next: (response) => this.searchReservations(),
          error: (err) => console.log(err)
        });
        break;
      default:
        alert('Seleccione un método de pago válido.');
    }
  }

  iniciarEstadia() {
    this.reservationService.startStay(this.reservationId, this.tokenStorage.getAccessToken() || '').subscribe({
      next: (response) => this.searchReservations(),
      error: (err) => console.log(err)
    });
  }

  // NUEVOS MÉTODOS PARA MANEJO DE IMÁGENES

  /**
   * Maneja la selección de archivos desde el input
   */
  async onFilesSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      await this.onDocumentFileSelected(files);
      // Limpiar el input para permitir seleccionar el mismo archivo de nuevo
      input.value = '';
    }
  }

  /**
   * Maneja el evento de arrastrar archivos sobre el área
   */
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  /**
   * Maneja cuando se sale del área de arrastre
   */
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  /**
   * Maneja cuando se sueltan archivos en el área
   */
  async onFilesDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (event.dataTransfer?.files) {
      const files = Array.from(event.dataTransfer.files);
      // Filtrar solo archivos de imagen
      const imageFiles = files.filter(
        file => file.type.startsWith('image/') ||
          file.type === 'application/pdf'
      );

      if (imageFiles.length !== files.length) {
        alert('Solo se pueden subir archivos de imagen o PDF.');
      }

      if (imageFiles.length > 0) {
        await this.onDocumentFileSelected(imageFiles);
      }
    }
  }

  async onDocumentFileSelected(files: File[]) {
    this.errorDocumentImage = '';
    this.loadingDocumentImage = true;
    this.documentImage = null;
    this.documentImagePreview = '';
    try {
      for (const file of Array.from(files)) {
        const valid = this.s3UploadService.validateFileReservations(file);
        if (!valid.valid) {
          this.errorDocumentImage = valid.error || 'Archivo no válido';
          this.loadingDocumentImage = false;
          return;
        }
        const preview = await this.s3UploadService.generatePreview(file);
        this.documentImagePreview = preview;
        const resp = await this.s3UploadService.uploadReservationFileToS3(file, this.reservationId);
        if (resp.success && resp.url) {
          this.documentImage = resp.url;
          this.documentData = resp;
        } else {
          this.errorDocumentImage = resp.error || 'Error subiendo imagen';
        }
      }
    } catch (e) {
      this.errorDocumentImage = 'Error procesando imagen';
    }
    this.loadingDocumentImage = false;
  }
}
